import { KpiCard, Link } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import {
  Box,
  Card,
  Flex,
  PercentageValue,
  WalletAddress
} from '@blockanalitica/ui';

export default function OverviewKpis({ data }) {
  return (
    <Flex flexDirection="column" gap="m">
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <Flex flexBasis="33%">
          <KpiCard
            title="Sold Collateral"
            data={data}
            field="sold_collateral"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: {
                    name: data.symbol,
                    address: data.collateral_address
                  },
                  iconSize: '3'
                }
              },
              valueTrendOptions: {
                currencyValueOptions: { currency: 'USD' }
              }
            }}
          />
        </Flex>
        <Flex flexBasis="33%">
          <KpiCard
            title="Recovered Debt"
            variant="dai"
            data={data}
            field="recovered_debt"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: tokensMapping('DAI'),
                  iconSize: '3'
                }
              }
            }}
          />
        </Flex>
        <Flex flexBasis="33%">
          <KpiCard
            title="Penalty"
            data={data}
            field="penalty_fee"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: tokensMapping('DAI'),
                  iconSize: '3'
                }
              }
            }}
            footer={
              <PercentageValue
                value={data.penalty}
                options={{
                  formatPercentageOptions: { maximumFractionDigits: 2 }
                }}
              />
            }
          />
        </Flex>
        <Flex flexBasis="33%">
          <Card gap="xs" display="flex" flexDirection="column">
            <Flex justifyContent="space-between" gap="xs">
              <Box>URN</Box>
              <WalletAddress
                options={{
                  inline: true,
                  showBlockie: false,
                  showCopyBtn: true
                }}
                address={data.urn}
              />
            </Flex>
            {data.cdp ? (
              <Flex justifyContent="space-between" gap="xs">
                <Box>CDP</Box>
                <Link to={`/collateral/core/${data.ilk}/cdps/${data.urn}`}>
                  {data.cdp}
                </Link>
              </Flex>
            ) : null}

            {data.owner ? (
              <Flex justifyContent="space-between" gap="s">
                <Box>Owner</Box>
                <WalletAddress
                  options={{
                    inline: true,
                    showBlockie: false,
                    showDebankLink: true,
                    showEthScanLink: true,
                    showZapperLink: true
                  }}
                  address={data.owner}
                />
              </Flex>
            ) : null}
            {data.proxy ? (
              <Flex justifyContent="space-between" gap="s">
                <Box>DS Proxy</Box>
                <WalletAddress
                  options={{
                    inline: true,
                    showBlockie: false,
                    showDebankLink: true,
                    showEthScanLink: true,
                    showZapperLink: true
                  }}
                  address={data.proxy}
                />
              </Flex>
            ) : null}
          </Card>
        </Flex>
      </Flex>
    </Flex>
  );
}
